import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useRef } from 'react';
import clsx from 'clsx';
import { InputRevertButton } from '../../buttons/RevertButton/InputRevertButton';
export function TextField({ name, labelText, labelAddition, defaultValue, required, autoFocus, handleInputChange, validateInput, tooltip, readOnly, maxLength, errors, placeholder, type = 'text', onRevert, revertButtonTitle, }) {
    const hasErrors = Boolean(errors === null || errors === void 0 ? void 0 : errors.length);
    const inputRef = useRef();
    function onChange(e) {
        if (handleInputChange) {
            handleInputChange(e);
        }
        // Only validate on change when there are errors:
        if (hasErrors && validateInput) {
            const el = e.target;
            validateInput(el);
        }
    }
    function onBlur(e) {
        if (validateInput) {
            const el = e.target;
            validateInput(el);
        }
    }
    return (_jsxs("div", Object.assign({ className: "form-field" }, { children: [_jsxs("label", Object.assign({ htmlFor: name }, { children: [labelText, labelAddition && _jsx("span", { children: labelAddition }), tooltip] })), _jsxs("div", Object.assign({ className: clsx('editing-form-control-nested-control', onRevert && 'input-revert-button__container') }, { children: [_jsx("input", { className: clsx('form-control', hasErrors && 'input-validation-error'), id: name, name: name, type: type, required: required, onChange: onChange, onBlur: onBlur, maxLength: maxLength, autoFocus: autoFocus, defaultValue: defaultValue, readOnly: readOnly, placeholder: placeholder, "data-label-text": labelText, ref: inputRef }), onRevert && (_jsx(InputRevertButton, { onClick: () => onRevert(inputRef.current), title: revertButtonTitle })), hasErrors && (_jsx("div", Object.assign({ className: "field-validation-error" }, { children: errors.map((error) => (_jsxs(Fragment, { children: [error, _jsx("br", {})] }, error))) })))] }))] })));
}
